import { lazy } from "react";

export const BlogFeed = lazy(() => import("./BlogFeed"));
